import { createRouter, createWebHistory } from 'vue-router';


const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/login/Login.vue'),
    meta: {
      title: '登录',
    },
  },

  {
    path: '/FullScreen',
    name: 'FullScreen',
    component: () => import('../views/homeScreen/components/FullScreen.vue'),
    meta: {
      title: '首页大屏',
    }
  },

  {
    path: '/backstage',
    name: 'backstage',
    component: () => import('../views/backstage/Backstage.vue'),
    meta: {
      title: '后台',
    },
    children: [
      //客户资源管理
      {
        path: '/CustomerResourceManagement',
        name: 'CustomerResourceManagement',
        meta: {
          title: '客户资源管理',
        },
        children: [
          {
            path: '/SystemResourceDetails',
            name: 'SystemResourceDetails',
            component: () => import('../views/cemOffline/customerManagement/systemResourceDetails/SystemResourceDetails.vue'),
            meta: {
              title: '系统资源明细',
            }
          },
          {
            path: '/RepetitiveResources',
            name: 'RepetitiveResources',
            component: () => import('../views/cemOffline/customerManagement/repetitiveResources/RepetitiveResources.vue'),
            meta: {
              title: '重复资源',
            }
          },

          {
            path: '/ClueManagement',
            name: 'ClueManagement',
            component: () => import('../views/cemOffline/customerManagement/clueManagement/ClueManagement.vue'),
            meta: {
              title: '线索管理',
            }
          },
          {
            path: '/MyClue',
            name: 'MyClue',
            component: () => import('../views/cemOffline/customerManagement/myClue/MyClue.vue'),
            meta: {
              title: '我的线索',
            }
          },
          {
            path: '/MyCustomer',
            name: 'MyCustomer',
            component: () => import('../views/cemOffline/customerManagement/myCustomer/MyCustomer.vue'),
            meta: {
              title: '我的意向客户',
            }
          },
          {
            path: '/PublicOcean',
            name: 'PublicOcean',
            component: () => import('../views/cemOffline/customerManagement/publicOcean/PublicOcean.vue'),
            meta: {
              title: '公海',
            }
          },
        ],
      },

      //订单管理
      {
        path: '/OrderManagement',
        name: 'OrderManagement',
        meta: {
          title: '订单管理',
        },
        children: [
          {
            path: '/PerformanceDistribution',
            name: 'PerformanceDistribution',
            component: () => import('../views/cemOffline/orderManagement/performanceDistribution/PerformanceDistribution.vue'),
            meta: {
              title: '业绩分配',
            }
          },
          {
            path: '/MyOrder',
            name: 'MyOrder',
            component: () => import('../views/cemOffline/orderManagement/myOrder/MyOrder.vue'),
            meta: {
              title: '我的订单',
            }
          },
        ],
      },

      //目标达成
      {
        path: '/GoalAchievement',
        name: 'GoalAchievement',
        meta: {
          title: '目标达成',
        },
        children: [
          {
            path: '/AnnualBudget',
            name: 'AnnualBudget',
            component: () => import('../views/cemOffline/goalAchievement/annualBudget/AnnualBudget.vue'),
            meta: {
              title: '年度预算',
            }
          },
          {
            path: '/StoreKpi',
            name: 'StoreKpi',
            component: () => import('../views/cemOffline/goalAchievement/storeKpi/StoreKpi.vue'),
            meta: {
              title: '门店KPI',
            }
          },
          {
            path: '/StaffKpi',
            name: 'StaffKpi',
            component: () => import('../views/cemOffline/goalAchievement/staffKpi/StaffKpi.vue'),
            meta: {
              title: '员工KPI',
            }
          },

          {
            path: '/PartnerProfitsSharing',
            name: 'PartnerProfitsSharing',
            component: () => import('../views/cemOffline/goalAchievement/partnerProfitsSharing/PartnerProfitsSharing.vue'),
            meta: {
              title: '生涯伙伴分润',
            }
          },

          {
            path: '/StoreProfitSharing',
            name: 'StoreProfitSharing',
            component: () => import('../views/cemOffline/goalAchievement/storeProfitSharing/StoreProfitSharing.vue'),
            meta: {
              title: '门店分润',
            }
          },

        ],
      },
      //产品管理
      {
        path: '/OfflineProductManagement',
        name: 'OfflineProductManagement',
        component: () => import('../views/cemOffline/productManagement/productManagement/ProductManagement.vue'),
        meta: {
          title: '产品管理',
        }
      },

      //  =====================================首页大屏=============================//

      {
        path: '/HomeScreen',
        name: 'HomeScreen',
        component: () => import('../views/homeScreen/HomeScreen.vue'),
        meta: {
          title: '首页大屏',
        }
      },


      //  =====================================账号管理=============================//
      {
        path: '/AdminManagement',
        name: 'AdminManagement',
        component: () => import('../views/accountManagement/adminManagement/AdminManagement.vue'),
        meta: {
          title: '管理员管理',
        }
      },

      {
        path: '/AccountStoreManagement',
        name: 'AccountStoreManagement',
        component: () => import('../views/accountManagement/storeManagement/StoreManagement.vue'),
        meta: {
          title: '门店管理',
        }
      },

      {
        path: '/DepartmentalStaffManagement',
        name: 'DepartmentalStaffManagement',
        component: () => import('../views/accountManagement/departmentalStaffManagement/DepartmentalStaffManagement.vue'),
        meta: {
          title: '部门员工管理',
        }
      },


      {
        path: '/ResponsibleManagement',
        name: 'ResponsibleManagement',
        component: () => import('../views/accountManagement/responsibleManagement/ResponsibleManagement.vue'),
        meta: {
          title: '董事合伙人管理',
        }
      },

      {
        path: '/provinceCenter',
        name: 'provinceCenter',
        component: () => import('../views/accountManagement/provinceCenter/provinceCenter.vue'),
        meta: {
          title: '省级运营中心管理',
        }
      },


      //  =====================================莘选测评=============================//
      {
        path: '/SxcpPuBen',
        name: 'SxcpPuBen',
        component: () => import('../views/sxcp/sxcpPuBen/SxcpPuBen.vue'),
        meta: {
          title: '普本版',
        }
      },

      {
        path: '/SxcpPuBenShop',
        name: 'SxcpPuBenShop',
        component: () => import('../views/sxcp/sxcpPubenShop/SxcpPubenShop.vue'),
        meta: {
          title: '普本版（商城专用）',
        }
      },

      {
        path: '/SxcpZhiBen',
        name: 'SxcpZhiBen',
        component: () => import('../views/sxcp/sxcpZhiBen/SxcpZhiBen.vue'),
        meta: {
          title: '职本版',
        }
      },

      {
        path: '/SxcpZhuanKe',
        name: 'SxcpZhuanKe',
        component: () => import('../views/sxcp/sxcpZhuanKe/SxcpZhuanKe.vue'),
        meta: {
          title: '专科版',
        }
      },


      {
        path: '/SxcpXuanKe',
        name: 'SxcpXuanKe',
        component: () => import('../views/sxcp/sxcpXuanKe/SxcpXuanKe.vue'),
        meta: {
          title: '选科版',
        }
      },

      {
        path: '/SxcpAccountManagement',
        name: 'SxcpAccountManagement',
        meta: {
          title: '账号管理',
        },
        children: [
          {
            path: '/StoreAccount',
            name: 'StoreAccount',
            component: () => import('../views/sxcp/sxcpAccountManagement/storeAccount/StoreAccount.vue'),
            meta: {
              title: '门店账号',
            }
          },
          {
            path: '/ActivityAccount',
            name: 'ActivityAccount',
            component: () => import('../views/sxcp/sxcpAccountManagement/activityAccount/ActivityAccount.vue'),
            meta: {
              title: '活动账号',
            }
          },

        ],
      },


      //  =====================================运营cem=============================//
      {
        path: '/StoreManagement',
        name: 'StoreManagement',
        meta: {
          title: '门店管理',
        },
        children: [
          {
            path: '/StoreDistribution',
            name: 'StoreDistribution',
            component: () => import('../views/cemOperation/storeManagement/storeDistribution/StoreDistribution.vue'),
            meta: {
              title: '门店分配',
            }
          },
          {
            path: '/MyStore',
            name: 'MyStore',
            component: () => import('../views/cemOperation/storeManagement/myStore/MyStore.vue'),
            meta: {
              title: '我的门店',
            }
          },
        ],
      },


      {
        path: '/operationOrderManagement',
        name: 'operationOrderManagement',
        meta: {
          title: '订单管理',
        },
        children: [
          {
            path: '/OrderConfirmation',
            name: 'OrderConfirmation',
            component: () => import('../views/cemOperation/orderManagement/orderConfirmation/OrderConfirmation.vue'),
            meta: {
              title: '订单确认',
            }
          },
          {
            path: '/MyOperationOrder',
            name: 'MyOperationOrder',
            component: () => import('../views/cemOperation/orderManagement/myOrder/MyOrder.vue'),
            meta: {
              title: '我的订单',
            }
          },
        ],
      },


      {
        path: '/Product',
        name: 'Product',
        meta: {
          title: '产品管理',
        },
        children: [
          {
            path: '/OperationProductManagement',
            name: 'OperationProductManagement',
            component: () => import('../views/cemOperation/product/productManagement/ProductManagement.vue'),
            meta: {
              title: '产品管理',
            }
          },
          {
            path: '/productTypeManagement',
            name: 'productTypeManagement',
            component: () => import('../views/cemOperation/product/productTypeManagement/productTypeManagement.vue'),
            meta: {
              title: '产品类别管理',
            }
          },
        ],
      },


      //分润规则
      {
        path: '/profitSharingRules',
        name: 'profitSharingRules',
        meta: {
          title: '分润规则设置',
        },
        children: [
          {
            path: '/StoreProfitSharingRules',
            name: 'StoreProfitSharingRules',
            component: () => import('../views/cemOperation/profitSharingRules/storeProfitSharingRules/StoreProfitSharingRules.vue'),
            meta: {
              title: '门店分润规则',
            }
          },
          {
            path: '/PartnerProfitSharingRules',
            name: 'PartnerProfitSharingRules',
            component: () => import('../views/cemOperation/profitSharingRules/partnerProfitSharingRules/PartnerProfitSharingRules.vue'),
            meta: {
              title: '合伙人分润规则',
            }
          },
        ],
      },

      {
        path: '/GoalAchievementOperation',
        name: 'GoalAchievementOperation',
        meta: {
          title: '目标达成',
        },
        children: [
          {
            path: '/AnnualBudgetOperation',
            name: 'AnnualBudgetOperation',
            component: () => import('../views/cemOperation/goalAchievement/annualBudget/AnnualBudget.vue'),
            meta: {
              title: '年度预算',
            }
          },
          {
            path: '/DepartmentKpi',
            name: '/DepartmentKpi',
            component: () => import('../views/cemOperation/goalAchievement/departmentKpi/DepartmentKpi.vue'),
            meta: {
              title: '部门KPI',
            }
          },
          {
            path: '/SubDepartmentKpi',
            name: '/SubDepartmentKpi',
            component: () => import('../views/cemOperation/goalAchievement/subDepartmentKpi/SubDepartmentKpi.vue'),
            meta: {
              title: '子部门KPI',
            }
          },
          {
            path: '/StaffKpiOperation',
            name: '/StaffKpiOperation',
            component: () => import('../views/cemOperation/goalAchievement/staffKpiOperation/StaffKpiOperation.vue'),
            meta: {
              title: '员工KPI',
            }
          },
        ],
      },
      //  =====================================格豆商城=============================//
      {
        path: '/ProductList',
        name: 'ProductList',
        component: () => import('../views/scoreShop/productList/productList/ProductList.vue'),
        meta: {
          title: '商品列表',
        }
      },

      {
        path: '/ShopOrder',
        name: 'ShopOrder',
        component: () => import('../views/scoreShop/shopOrder/shopOrder/ShopOrder.vue'),
        meta: {
          title: '商城订单',
        }
      },


      {
        path: '/ScoreManagement',
        name: 'ScoreManagement',
        meta: {
          title: '格豆管理',
        },
        children: [
          {
            path: '/ScoreChangeDetails',
            name: 'ScoreChangeDetails',
            component: () => import('../views/scoreShop/scoreManagement/scoreChangeDetails/ScoreChangeDetails.vue'),
            meta: {
              title: '格豆变更明细',
            }
          },
          {
            path: '/UserScoreList',
            name: 'UserScoreList',
            component: () => import('../views/scoreShop/scoreManagement/userScoreList/UserScoreList.vue'),
            meta: {
              title: '用户格豆列表',
            }
          },
        ],
      },
      {
        path: '/layoutManagement',
        name: 'layoutManagement',
        component: () => import('../views/scoreShop/layoutManagement/layoutManagement.vue'),
        meta: {
          title: '商城首页布局管理',
        }
      },
      {
        path: '/productProfitManage',
        name: 'productProfitManage',
        component: () => import('../views/scoreShop/productProfitManage/productProfitManage.vue'),
        meta: {
          title: '商品分润管理',
        }
      },
      {
        path: '/productOrderManage',
        name: 'productOrderManage',
        component: () => import('../views/scoreShop/productOrderManage/productOrderManage.vue'),
        meta: {
          title: '商城订单管理',
        }
      },
      {
        path: '/couponManage',
        name: 'couponManage',
        component: () => import('../views/scoreShop/couponManage/couponManage.vue'),
        meta: {
          title: '优惠券管理',
        }
      },
      {
        path: '/customerRecord',
        name: 'customerRecord',
        component: () => import('../views/scoreShop/customerRecord/customerRecord.vue'),
        meta: {
          title: '客户登录记录',
        }
      },
      {
        path: '/evaluateManage',
        name: 'evaluateManage',
        component: () => import('../views/scoreShop/evaluateManage/evaluateManage.vue'),
        meta: {
          title: '评价管理',
        }
      },
      {
        path: '/profitWithdrawal',
        name: 'profitWithdrawal',
        component: () => import('../views/scoreShop/profitWithdrawal/profitWithdrawal.vue'),
        meta: {
          title: '分润提现',
        }
      },
      {
        path: '/commission',
        name: 'commission',
        component: () => import('../views/scoreShop/commission/commission.vue'),
        meta: {
          title: '手续费提现',
        }
      },
      {
        path: '/receivingAccount',
        name: 'receivingAccount',
        component: () => import('../views/scoreShop/receivingAccount/receivingAccount.vue'),
        meta: {
          title: '收款账户管理',
        }
      },



      //  =====================================修改密码=============================//
      {
        path: '/ChangePassword',
        name: 'ChangePassword',
        component: () => import('../views/personalInformation/changePassword/ChangePassword.vue'),
        meta: {
          title: '修改密码',
        }
      },

    ]
  },

  //  =====================================格豆商城 单页面=============================//
  {
    path: '/ProductDetails',
    name: 'ProductDetails',
    component: () => import('../views/scoreShop/productList/productList/productDetails/ProductDetails.vue'),
    meta: {
      title: '商品详情',
    }
  },
  {
    path: '/ConfirmOrder',
    name: 'ConfirmOrder',
    component: () => import('../views/scoreShop/productList/productList/productDetails/confirmOrder/ConfirmOrder.vue'),
    meta: {
      title: '确认订单',
    }
  },
  {
    // path: '/SubmitOrder/:productId/:number/:beans/:money',
    path: '/SubmitOrder',
    name: 'SubmitOrder',
    component: () => import('../views/scoreShop/productList/productList/productDetails/confirmOrder/submitOrder/SubmitOrder.vue'),
    meta: {
      title: '提交订单',
    }
  },
  //  =====================================用户协议 单页面=============================//
  {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: () => import('../views/agreement/privacyPolicy/PrivacyPolicy.vue'),
    meta: {
      title: '隐私政策',
    }
  },
  {
    path: '/ServiceAgreement',
    name: 'ServiceAgreement',
    component: () => import('../views/agreement/serviceAgreement/ServiceAgreement.vue'),
    meta: {
      title: '服务协议',
    }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
